export default __webpack_public_path__ + "static/dust2-logo-36a54b3a2bcba8bb5f9aaf388d9b6003.png";